import { defineStore } from 'pinia'

export const useToast = defineStore('toast', {
  state: () => ({
    message: '',
    showUndo: false,
    duration: 4000,
    undoHandler: null,
    id: 0,
  }),

  actions: {
    show(options = {}) {
      const {
        message = '',
        showUndo = false,
        duration = 4000,
        onUndo = null,
      } = options

      if (!message) return

      this.message = message
      this.showUndo = showUndo
      this.duration = duration
      this.undoHandler = onUndo
      this.id += 1
    },

    runUndo() {
      if (typeof this.undoHandler === 'function') {
        this.undoHandler()
      }
    },

    dismiss() {
      this.message = ''
      this.showUndo = false
      this.undoHandler = null
    },
  },
})
